/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { type ComponentAttrs } from 'flarum/common/Component';
import type Mithril from 'mithril';

// Shepherd is loaded from a CDN by `loadDynLib` and ships no types in this
// project; `HomeTourState` owns the canonical hand-written shapes. Type-only
// import, so this does not create a runtime cycle with HomeTourState -> TourProgress.
import type { ShepherdTour } from '../states/HomeTourState';

export interface TourProgressAttrs extends ComponentAttrs {
	tour: ShepherdTour;
}

export default class TourProgress extends Component<TourProgressAttrs> {
	oninit(vnode: Mithril.Vnode<TourProgressAttrs, this>) {
		super.oninit(vnode);
	}

	view(): Mithril.Children {
		const { tour } = this.attrs;

		const currentStepIndex = tour.steps.indexOf(tour.currentStep);

		return (
			<div className="TourProgress">
				{tour.steps.map((_, index) => {
					const isCurrent = index === currentStepIndex;

					return <div className={`TourProgress-dot ${isCurrent ? 'is-current' : ''}`}></div>;
				})}
			</div>
		);
	}
}
